export const dependencyRefusal = (said?: Readonly<Record<string, unknown>>) => said?.["code"] === 100 && said["subcode"] === 3858848;
